module.exports = __webpack_public_path__ + "img/kontakty.85d76e07.svg";